import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { useEffect } from 'react'
import { noop } from 'utils'
export type LockCourseBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const LockCourseBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: LockCourseBtnProps) => {
  const [state, { lock }] = useAccountActions()

  useEffect(() => {
    if (state.matches('success')) {
      onDone('User has been Locked')
    } else if (state.matches('failed')) {
      onError('Failed locking user, please try again')
    }
  }, [state, onDone, onError])

  return (
    <Button
      variant="buttons.outline"
      type="button"
      disabled={disabled || state.matches('syncing')}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 90,
        height: 40,
        mx: 5,
        borderColor: state.matches('failed') ? 'warning' : 'text',
      }}
      onClick={() => {
        lock({ userId })
      }}>
      {state.matches('syncing') ? <Loading /> : <span>Lock</span>}
    </Button>
  )
}
